// api 地址合集
import generic from "./module/generic";
import sku from "./module/sku";
import user from "./module/user";
import report from "./module/report";
import sellLiquor from "./module/sellLiquor";
import tms from "./module/tms";
export default { ...generic, ...sku, ...user, ...report, ...sellLiquor, ...tms };
